import { render, staticRenderFns } from "./TargetIpccMonitoring.vue?vue&type=template&id=bb3800c6&scoped=true"
import script from "./TargetIpccMonitoring.vue?vue&type=script&lang=js"
export * from "./TargetIpccMonitoring.vue?vue&type=script&lang=js"
import style0 from "./TargetIpccMonitoring.vue?vue&type=style&index=0&id=bb3800c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3800c6",
  null
  
)

export default component.exports